import { flatten } from 'lodash';
import { call, put, all } from 'redux-saga/effects';
import { fetchCensusTable } from '../fetch-census-table';
import { fetchGraphs } from '../fetch-graphs';

const prepareGraphs = (graphs) => flatten(graphs)
    .filter(Boolean)
    .reduce((acc, graph) => {
      acc[graph.name] = graph;
      return acc;
    }, {});

export function* fetchSingleParcelGraphs({
  serverConfig,
  filterString,
  report,
  identifier,
  finalParcels,
  config,
  parsedBbox,
  point,
}) {
  const { censusTables, graphs } = yield all({
    graphs: call(fetchGraphs, {
      serverConfig,
      filterString,
      report,
    }),
    censusTables: call(fetchCensusTable, {
      filterString,
      report: config.report,
    }),
  });

  // Fetch graphs after the rest of the report loads.
  const newPayload = {
    key: identifier,
    parcels: finalParcels,
    report: config.report,
    bbox: parsedBbox,
    graphs: prepareGraphs(graphs),
    censusTables,
    point,
  };
  yield put({
    type: 'UPDATE_REPORT_CONTENT',
    payload: newPayload,
  });
  yield put({
    type: 'UPDATE_SIDE_PANEL_CONTENT',
    payload: newPayload,
  });
}
